export type FooterNavLink = {
  label: string;
  to?: string;
  href?: string;
};

export type FooterColumn = {
  title: string;
  links: FooterNavLink[];
};

export const footerColumns: FooterColumn[] = [
  {
    title: "Moodnotes",
    links: [
      { label: "开始创作", to: "/moodboard" },
      { label: "首页", to: "/" },
    ],
  },
  {
    title: "MoodShow",
    links: [
      { label: "关于我们", to: "/site/aboutUs" },
      { label: "商务合作", to: "/site/cooperation" },
      { label: "隐私协议", to: "/site/privacy" },
      { label: "服务条款", to: "/site/service" },
    ],
  },
  {
    title: "帮助中心",
    links: [
      { label: "功能介绍", to: "/site/helpFunction" },
      { label: "工具介绍", to: "/site/helpTool" },
      { label: "意见反馈", href: "mailto:MoodShow@kumhosunny.com?subject=意见反馈" },
    ],
  },
];

export const footerContact = {
  title: "联系我们",
  phoneLabel: "联系电话",
  phone: "021-62969608",
  phoneHref: "tel:02162969608",
  emailLabel: "官方邮箱",
  email: "MoodShow@kumhosunny.com",
};

export const footerSocial = [
  {
    id: "wechat",
    label: "公众号",
    src: "/image/qr-wechat.png",
    alt: "锦湖日丽看塑界微信公众号二维码",
  },
  {
    id: "xiaohongshu",
    label: "小红书",
    src: "/image/qr-xiaohongshu.png",
    alt: "MoodShow 小红书二维码",
  },
] as const;

export const footerLegal = {
  copyright: "Copyright 2022 上海锦湖日丽塑料有限公司版权所有",
  icp: "沪ICP备05064293号",
  icpHref: "https://beian.miit.gov.cn/",
};
